import React, { Component, Fragment } from 'react'
import { Collapse } from 'antd'
import InfoText from '../../../../../elements/InfoText'
import Overview from './Overview'
import PayLinesList from '../PayLinesList'

const { Panel } = Collapse

class Details extends Component {
  render() {
    return (
      <Fragment>
        <Collapse bordered={false} defaultActiveKey={['overview', 'items']}>
          <Panel header={<h3>Overview</h3>} key="overview">
            <Overview {...this.props} ref={this.props.formRef} />
          </Panel>
          <Panel header={<h3>Payable Items</h3>} key="items">
            <PayLinesList {...this.props} />
          </Panel>
        </Collapse>
        <InfoText text={'To Update Receipt Details please click on Update Button above.'} />
      </Fragment>
    )
  }
}

Details.propTypes = {}
Details.defaultProps = {}

export default Details
